import axios from 'axios';
import { success } from 'redux-saga-requests';
import {
  AUTHKIT_SESSION, LOGOUT, GET_USER_PROFILE,
} from '../constants';

const parseJSON = (s) => {
  try {
    return JSON.parse(s);
  } catch (e) {
    return null;
  }
};

const userToken = parseJSON(window.localStorage.token)
  || parseJSON(window.sessionStorage.token)
  || null;

const userIntialState = {
  token: userToken,
  profile: null,
  organization: null,
};

if (userToken && userToken.access_token) {
  axios.defaults.headers.common.Authorization = `Bearer ${
    userToken.access_token
  }`;
}

export default function (state = userIntialState, action) {
  switch (action.type) {
    /* istanbul ignore next */
    case AUTHKIT_SESSION: {
      const token = action.payload.data;
      try {
        window.localStorage.setItem('token', JSON.stringify(token));
        window.sessionStorage.removeItem('token');
      } catch (error) {
        //
      }
      axios.defaults.headers.common.Authorization = `Bearer ${
        token.access_token
      }`;

      return {
        ...state,
        token,
      };
    }
    case success(GET_USER_PROFILE):
      return {
        ...state,
        profile: action.payload.data.content,
      };
    case LOGOUT: {
      delete axios.defaults.headers.common.Authorization;
      try {
        window.localStorage.removeItem('token');
        window.sessionStorage.removeItem('token');
      } catch (error) {
        //
      }
      return {
        ...state,
        token: null,
      };
    }
    default:
      return state;
  }
}
